import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./SwiperStyles.css";

// import required modules
import { Navigation } from "swiper/modules";

const SwiperListOfCategoriesLayout = ({ children }: { children: React.ReactNode }) => {
  const breakpoints = {
    300: { slidesPerView: 4.2 },
    360: { slidesPerView: 4.4 },
    400: { slidesPerView: 4.7 },
    480: { slidesPerView: 5.3 },
    560: { slidesPerView: 5.9 },
    640: { slidesPerView: 6.4 },
    768: { slidesPerView: 7.3 },
    900: { slidesPerView: 8.3 },
    1080: { slidesPerView: 9.3 },
    1280: { slidesPerView: 10.3 },
    1360: { slidesPerView: 11 },
  };

  return (
    <Swiper
      breakpoints={breakpoints}
      slidesPerView={4.2}
      spaceBetween={8}
      freeMode={true}
      pagination={{
        clickable: true,
      }}
      modules={[Navigation]}
      className="mySwiper"
    >
      {React.Children.map(children, (child, index) => (
        <SwiperSlide key={index}>{child}</SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SwiperListOfCategoriesLayout;
